module.exports = __webpack_public_path__ + "static/media/team-1.a65ae518.jpg";